export default function getFacilityLabels(data: { facilityName: string }[], minLength: number = 4): string[] {
  const result = data.map(d => d.facilityName);
  while(result.length < minLength) {
    result.push('');
  }
  return result;
}